import React from 'react';

const HeroSection: React.FC = () => {

  return (
    <section className="bg-white px-4 pt-16">
      <div className="mx-auto px-4 md:px-10 lg:px-32 w-full">
        {/* Main Headline */}
        <div className="lg:text-center">
          <h1 className="font-bold lg:text-[42px] md:text-[32px] text-[28px] leading-[100%] text-[#192842] tracking-[1%] mb-1">
          Join Rob Bruggeman's Elite Club to Achieve 
          </h1>
          <h1 className="font-bold lg:text-[42px] md:text-[32px] text-[28px] leading-[100%] text-[#192842] tracking-[1%]">
          Life-Changing Investment Results
          </h1>
        </div>
        
        {/* Body Text */}
        <div className="max-w-[970px] mx-auto text-justify space-y-6 mb-12 mt-10" style={{ hyphens: 'auto', textAlign: 'justify', textJustify: 'inter-word' }}>
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
            For over 20 years, he has been helping investors grow their capital by investing in an overlooked and misunderstood sector.
          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
            We are talking about mining, the industry that can generate fortunes for those that invest in the most prospective companies, at the right time.
          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
            He is a well-known and respected analyst and industry insider...and now he is ready to share his proven methodology with you.
          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
            Rob wants you to be as successful as his investors.
          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
            This is why he built <strong>The Wealthy Miner—a service focused on bringing the best mining ideas, vetted by Rob's multi-decade experience, to every individual investor.</strong>
          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
            Yes, you can invest in the same junior mining companies as the wealthiest and most successful investors.
          </p>
          
          <p className="lg:text-[22px] md:text-[18px] text-[16px] font-[400] text-[#192842] lg:leading-[32px] md:leading-[26px] leading-[23px]">
            And Rob is here to help you make your next investment decision.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
